import React from 'react';
import {
    ProductGridViewUiMode,
    PRODUCT_GRID_VIEW_UI_MODES,
} from '../../utils/productGridView';

interface Props {
    value: ProductGridViewUiMode;
    onChange: (mode: ProductGridViewUiMode) => void;
}

const MODE_LABELS: Record<ProductGridViewUiMode, string> = {
    grid6: '6 products per row',
    grid8: '8 products per row',
};

const IconGrid8: React.FC = () => (
    <svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true">
        <rect x="3" y="3" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="1.5" />
        <line x1="7.5" y1="3" x2="7.5" y2="21" stroke="currentColor" strokeWidth="1" />
        <line x1="12" y1="3" x2="12" y2="21" stroke="currentColor" strokeWidth="1" />
        <line x1="16.5" y1="3" x2="16.5" y2="21" stroke="currentColor" strokeWidth="1" />
        <line x1="3" y1="12" x2="21" y2="12" stroke="currentColor" strokeWidth="1" />
    </svg>
);

const IconGrid6: React.FC = () => (
    <svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true">
        <rect x="3" y="3" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="1.5" />
        <line x1="9" y1="3" x2="9" y2="21" stroke="currentColor" strokeWidth="1" />
        <line x1="15" y1="3" x2="15" y2="21" stroke="currentColor" strokeWidth="1" />
        <line x1="3" y1="9" x2="21" y2="9" stroke="currentColor" strokeWidth="1" />
        <line x1="3" y1="15" x2="21" y2="15" stroke="currentColor" strokeWidth="1" />
    </svg>
);

const ICONS: Record<ProductGridViewUiMode, React.FC> = {
    grid6: IconGrid6,
    grid8: IconGrid8,
};

export const ProductGridViewToggle: React.FC<Props> = ({ value, onChange }) => (
    <div className="product-grid-view-toggle" role="group" aria-label="View">
        <span className="product-grid-view-toggle__label desktop-only">View</span>
        {PRODUCT_GRID_VIEW_UI_MODES.map((mode) => {
            const Icon = ICONS[mode];
            const label = MODE_LABELS[mode];
            const isActive = value === mode;
            return (
                <button
                    key={mode}
                    type="button"
                    className={
                        'product-grid-view-toggle__btn' +
                        (isActive ? ' product-grid-view-toggle__btn--active' : '')
                    }
                    aria-pressed={isActive}
                    aria-label={label}
                    title={label}
                    onClick={() => onChange(mode)}
                >
                    <Icon />
                </button>
            );
        })}
    </div>
);

export default ProductGridViewToggle;
